/* nori-exit-offer.js — the exit-intent popup (Dawn 15.x).
   Config from window.NORI_EXIT, written by sections/nori-exit-offer.liquid.

   "Exit" means exactly:
     - Desktop (hover-capable device): the cursor leaves the viewport through the
       TOP edge, after the minimum dwell time.
     - Phone/tablet (no hover): the browser back press — button or swipe-back —
       but ONLY on the first page of the visit, where back genuinely leaves the
       site. One history entry is added there; the popup consumes the first back,
       the second back always leaves. Chrome skips the entry if the visitor never
       interacted with the page, in which case back exits directly.
   Not detectable in any browser (nothing fires in time to show UI): closing the
   tab, switching tabs or apps, the home button, typing a new URL.

   Everything inside one try/catch; no dependencies. */
(function () {
  "use strict";
  try {
    var C = window.NORI_EXIT;
    if (!C) return;
    var root = document.getElementById("nori-exit");
    if (!root) return;

    var STATE_KEY = "nori_exit";
    var SHOWN_KEY = "nori_exit_shown";
    var PV_KEY = "nori_exit_pv";
    var APPLIED_KEY = "nori_exit_applied";
    var LOCK = "nori-wa-lock"; /* shared with the WhatsApp popup: one popup at a time */
    var DAY = 864e5;

    function lsGet(k) { try { return JSON.parse(localStorage.getItem(k) || "null"); } catch (e) { return null; } }
    function lsSet(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
    function ssGet(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
    function ssSet(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }

    var qs = new URLSearchParams(location.search);
    if (qs.get("nori_exit") === "off") return;
    var force = qs.get("nori_exit") === "show";

    /* page-view counter: back only means "exit" on the first page of the visit */
    var pv = parseInt(ssGet(PV_KEY) || "0", 10) + 1;
    ssSet(PV_KEY, String(pv));

    if (!force && !C.designMode) {
      var st = lsGet(STATE_KEY);
      if (st && st.status === "dismissed" && Date.now() - st.at < C.dismissDays * DAY) return;
      if (ssGet(SHOWN_KEY)) return;
      if (C.skipVerified) {
        var wa = lsGet("nori_wa");
        if (wa && (wa.status === "issued" || wa.status === "existing") && Date.now() - wa.at < 365 * DAY) return;
      }
    }

    /* ---- events: server log + GTM dataLayer (same channel as the WhatsApp popup) */
    function track(type, extra) {
      try { (window.dataLayer = window.dataLayer || []).push({ event: "nori_exit_" + type }); } catch (e) {}
      if (!C.apiBase) return;
      var body = JSON.stringify(Object.assign({ event: "exit_" + type, template: C.template }, extra || {}));
      try {
        if (navigator.sendBeacon) {
          navigator.sendBeacon(C.apiBase + "/v1/events", new Blob([body], { type: "text/plain" }));
        } else {
          fetch(C.apiBase + "/v1/events", { method: "POST", headers: { "Content-Type": "text/plain" }, body: body, keepalive: true }).catch(function () {});
        }
      } catch (e) {}
    }

    function applyCode(trigger) {
      if (ssGet(APPLIED_KEY) === C.code) return;
      fetch("/discount/" + encodeURIComponent(C.code) + "?redirect=/", { credentials: "same-origin" })
        .then(function () { ssSet(APPLIED_KEY, C.code); track("applied", { trigger: trigger }); showAppliedLine(); })
        .catch(function () {});
    }
    function showAppliedLine() {
      var el = root.querySelector("[data-ne-applied]");
      if (el) el.hidden = false;
    }

    /* ---- never over the cart, the checkout, or the WhatsApp popup ---- */
    function visible(el) {
      if (!el) return false;
      var r = el.getBoundingClientRect();
      return r.width > 200 && r.height > 200;
    }
    function blocked() {
      if (document.documentElement.classList.contains(LOCK)) return true;   /* a nori popup is open */
      if (qs.get("openCart") === "true") return true;
      if (document.getElementById("gokwik-iframe")) return true;
      if (document.querySelector("cart-drawer.active")) return true;
      var host = document.querySelector("shadow-dom-container");
      if (host && host.shadowRoot && (visible(host.shadowRoot.querySelector(".sidecart")) || visible(host.shadowRoot.querySelector(".overlay")))) return true;
      return false;
    }

    var panel = root.querySelector(".nori-exit__panel");
    var copyBtn = root.querySelector("[data-ne-copy]");
    var codeEl = root.querySelector("[data-ne-code]");
    var opened = false;
    var armed = false;
    var lastFocus = null;

    function open(trigger) {
      if (opened) return;
      if (!force && !C.designMode) {
        if (!armed) return;
        if (blocked()) return;
      }
      opened = true;
      ssSet(SHOWN_KEY, "1");
      lastFocus = document.activeElement;
      root.hidden = false;
      document.documentElement.classList.add(LOCK);
      if (C.autoApply) applyCode(trigger);
      setTimeout(function () { var b = root.querySelector("[data-ne-done]"); if (b) b.focus(); }, 30);
      track("shown", { trigger: trigger });
    }
    function close(reason) {
      root.hidden = true;
      document.documentElement.classList.remove(LOCK);
      if (reason === "dismissed") {
        lsSet(STATE_KEY, { status: "dismissed", at: Date.now() });
        track("dismissed");
      }
      if (lastFocus && lastFocus.focus) try { lastFocus.focus(); } catch (e) {}
    }

    copyBtn.addEventListener("click", function () {
      var code = codeEl.textContent.trim();
      var done = function () {
        copyBtn.textContent = C.copy.copied;
        track("copied");
        if (!C.autoApply) applyCode("copy");
        setTimeout(function () { copyBtn.textContent = C.copy.copyLabel; }, 1800);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(done, done);
      else { var r = document.createRange(); r.selectNodeContents(codeEl); var s = getSelection(); s.removeAllRanges(); s.addRange(r); try { document.execCommand("copy"); } catch (e) {} done(); }
    });
    root.querySelector("[data-ne-done]").addEventListener("click", function () { close("dismissed"); });
    root.querySelector("[data-ne-close]").addEventListener("click", function () { close("dismissed"); });
    root.querySelector("[data-ne-backdrop]").addEventListener("click", function () { close("dismissed"); });
    document.addEventListener("keydown", function (e) {
      if (root.hidden) return;
      if (e.key === "Escape") { close("dismissed"); return; }
      if (e.key === "Tab") {
        var f = panel.querySelectorAll("button:not([disabled])");
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });

    /* ---- theme editor: show only when the merchant selects the section ---- */
    if (C.designMode) {
      document.addEventListener("shopify:section:select", function (e) { if (e.detail && e.detail.sectionId === C.sectionId) { opened = false; root.hidden = false; } });
      document.addEventListener("shopify:section:deselect", function (e) { if (e.detail && e.detail.sectionId === C.sectionId) root.hidden = true; });
      return;
    }
    if (force) { armed = true; open("forced"); return; }

    var isTouch = matchMedia("(hover: none), (pointer: coarse)").matches;

    /* Desktop: cursor leaves through the top edge (toward tabs / URL bar / close).
       Two paths for reliability across browsers: mouseout leaving the document
       with no relatedTarget, and mouseleave off the root element. Both restrict
       to the top edge (clientY near 0) so leaving through the sides or bottom is
       ignored. The threshold is a few px because browsers sometimes report the
       final sample at clientY 1-3 rather than exactly 0. */
    if (C.desktopExit && !isTouch) {
      var topExit = function (e) {
        if (opened) return;
        if (e.clientY <= 3 && (e.relatedTarget == null || e.type === "mouseleave")) open(e.type);
      };
      document.addEventListener("mouseout", topExit);
      document.documentElement.addEventListener("mouseleave", topExit);
    }

    /* Phones: back press on the landing page only. One extra history entry is
       pushed after the first interaction (Chrome ignores gesture-less entries);
       the first back shows the popup, the second back leaves. */
    if (C.mobileBack && isTouch && pv === 1) {
      var trapSet = false;
      var setTrap = function () {
        if (trapSet) return;
        trapSet = true;
        try { history.pushState({ nori_exit: 1 }, ""); } catch (e) {}
      };
      ["scroll", "touchstart", "pointerdown", "keydown"].forEach(function (ev) {
        window.addEventListener(ev, setTrap, { once: true, passive: true });
      });
      window.addEventListener("popstate", function () {
        if (trapSet && !opened) open("back");
      });
    }

    function arm() {
      setTimeout(function () {
        armed = true;
        /* an exit can fire any moment now: fetch the hero so the card never opens blank */
        var hero = root.querySelector(".nori-exit__hero img");
        if (hero) hero.loading = "eager";
      }, C.minDwellMs);
    }
    if (document.readyState === "complete") arm();
    else window.addEventListener("load", arm);
    /* bfcache restore (mobile back-forward): timers and flags survive; nothing to redo */
  } catch (e) {
    try { console.warn("nori-exit-offer:", e); } catch (_) {}
  }
})();
